import ServiceCategoryPage from "../components/ServiceCategoryPage";
import helperService from "../data/services/helperService";

function Helper() {
  return <ServiceCategoryPage service={helperService} />;
}

export default Helper;